import * as React from 'react';
import * as Leaflet from 'leaflet';

import { config } from '../config';
import marker from './marker.svg';

import 'leaflet/dist/leaflet.css';

const tileSetTemplate = `https://api.mapbox.com/styles/v1/mapbox/streets-v11/tiles/{z}/{x}/{y}{r}?access_token=${config.mapboxToken}`;

interface Props {
  coords: Array<readonly [number, number]>;
  className?: string;
  mapOptions?: Leaflet.MapOptions;
}

export const Map = ({ coords, className = '', mapOptions = {} }: Props) => {
  const mapContainer = React.useRef<HTMLDivElement>(null);
  const zoom = 15;

  React.useEffect(() => {
    if (mapContainer.current) {
      const icon = Leaflet.icon({ iconUrl: marker, iconAnchor: [15, 30] });
      const markers = coords.map(([lat, lng]) =>
        Leaflet.marker([lat, lng], { icon }),
      );

      const map = Leaflet.map(mapContainer.current, {
        scrollWheelZoom: false,
        dragging: false,
        tap: false,
        ...mapOptions,
      });

      const markerGroup = Leaflet.featureGroup(markers).addTo(map);
      map.fitBounds(markerGroup.getBounds(), {
        maxZoom: zoom,
        padding: [15, 15],
      });

      Leaflet.tileLayer(tileSetTemplate, {
        tileSize: 512,
        zoomOffset: -1,
      }).addTo(map);

      // clean up the map upon unmount
      return () => {
        map.remove();
      };
    }
    // this stops the map re-rendering unless the coords change
    // This is an optimization that may need to change if other map
    // options are allowed.
  }, [coords.toString()]);

  return <div ref={mapContainer} className={`z-0 ${className}`}></div>;
};
